import types from '../types'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

const server = getApiServer()

export const initializeSmart = (iss, launch) => dispatch => {
  dispatch({ type: types.FHIR_SMART_INITIALIZE, iss, launch })
  dispatch(fhirGetMetadata(iss))
}

const fhirGetMetadata = iss => (dispatch) => {
  dispatch({ type: types.FHIR_GET_METADATA, iss })

  axios
    .get(`${iss}/metadata`)
    .then(response => {
      const conformance = response.data
      const secExtensions = conformance.rest[0].security.extension.find(
        ext =>
          ext.url ===
          'http://fhir-registry.smarthealthit.org/StructureDefinition/oauth-uris'
      ).extension
      const authorizeExt = secExtensions.find(ext => ext.url === 'authorize')
      const tokenExt = secExtensions.find(ext => ext.url === 'token')

      if (
        conformance.software &&
        conformance.software.name &&
        conformance.software.name === 'Epic'
      ) {
        window.sessionStorage.setItem('ehr', 'Epic')
      } else {
        window.sessionStorage.setItem('ehr', 'Unknown')
      }

      const epicVersion = conformance.software.version
      dispatch(
        fhirGetMetadataSucceeded(authorizeExt.valueUri, tokenExt.valueUri, epicVersion)
      )
    })
    .catch(error => {
      dispatch(fhirGetMetadataFailed(error.toString()))
    })
}
const fhirGetMetadataSucceeded = (authorizeUrl, tokenUrl, epicVersion) => ({
  type: types.FHIR_GET_METADATA_SUCCEEDED,
  authorizeUrl,
  tokenUrl,
  epicVersion
})
const fhirGetMetadataFailed = error => ({
  type: types.FHIR_GET_METADATA_FAILED,
  error
})

export const generateTokenUri = (body) => (dispatch) => {
  dispatch({ type: types.FHIR_GENERATE_TOKEN_URI_REQUESTED })
  axios.post(`${server}/api/authorize`, body, { withCredentials: true })
    .then((response) => {
      const { uri } = response.data
      dispatch(generateTokenUriSucceeded(uri))
    })
    .catch((err) => {
      dispatch(generateTokenUriFailed(err.toString()))
    })
}

const generateTokenUriSucceeded = (data) => ({
  type: types.FHIR_GENERATE_TOKEN_URI_FULFILLED,
  payload: data
})

const generateTokenUriFailed = (error) => ({
  type: types.FHIR_GENERATE_TOKEN_URI_REJECTED,
  error
})

export const getAccessToken = uri => (dispatch) => {
  axios.post(`${server}/api/token`, { uri }, { withCredentials: true })
    .then((response) => {
      dispatch(accessTokenReceived(response.data))
    })
    .catch(() => {
      dispatch(
        fhirError('FHIR_AT_1', 'Unable to authenticate user. Please launch Lupus Advisor from an Epic System.')
      )
    })
}

const accessTokenReceived = tokenResponsePayload => ({
  type: types.FHIR_ACCESS_TOKEN_RECEIVED,
  tokenResponsePayload
})

// Used to signify an error.
const fhirError = (code, description) => ({
  type: types.FHIR_ERROR,
  code,
  description
})
